import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Button, ButtonType, CloseButtonLabel, ProgressDots } from '../atoms';
import { Dialog } from '../molecules';
import { Colors } from '../styles';
import { MealAIInputImage } from './meal_ai_input_image';
export const MealTaskAboutDialog = ({ onClickSuccess, onClickCancel, classObject }) => {
    const [pageIndex, setPageIndex] = React.useState(0);
    const pages = [
        {
            title: '食事を記録して\n健康管理しませんか？',
            description: '記録することで食べたものを客観的に管理できます。食事記録でダイエットの効果が2倍になると言われていますよ！',
            buttonText: '次へ',
        },
        {
            title: 'AIがざっくり入力を\n栄養素に変換！',
            description: 'メニュー名や食材名をざっくり打つだけで、AIがカロリーと栄養素を自動計算。リストから探さなくていいから、食後すぐにサッと記録できます。',
            buttonText: 'さっそく食事管理する！',
        },
    ];
    const isLastPage = () => {
        return pageIndex === pages.length - 1;
    };
    const onClickNext = () => (isLastPage() ? onClickSuccess() : setPageIndex(pageIndex + 1));
    const isAIInputPage = pageIndex === 1;
    const currentPage = pages[pageIndex];
    return (React.createElement(Dialog, { onClickCancel: onClickCancel, isCloseButton: true, closeButtonLabel: CloseButtonLabel.Close, strictSameSize: true, classObject: [styles.dialog, classObject], content: React.createElement("div", { className: css(styles.content) },
            isAIInputPage ? (React.createElement(MealAIInputImage, null)) : (React.createElement("img", { className: css(styles.image), src: "/assets/images/dialog/meal_task_about_dialog_effectiveness.jpg" })),
            React.createElement("div", { className: css(styles.info, isAIInputPage && styles.infoAIInput) },
                React.createElement("div", { className: css(styles.title) }, currentPage.title),
                React.createElement("div", { className: css(styles.description) }, currentPage.description)),
            React.createElement(ProgressDots, { classObject: styles.progressDots, length: pages.length, currentIndex: pageIndex }),
            React.createElement(Button, { className: css(styles.button), isRadius: true, buttonType: ButtonType.pink, onClick: onClickNext }, currentPage.buttonText)) }));
};
const styles = StyleSheet.create({
    dialog: {
        maxWidth: 327,
        backgroundColor: Colors.White,
        transform: 'translate(-50%, calc(-50% - 30px))',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        maxHeight: 'calc(100vh - 90px)',
        paddingBottom: 20,
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    image: {
        width: 327,
        height: 327,
        borderRadius: '8px 8px 0 0',
        flexShrink: 0,
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        width: 290,
        height: 124,
        textAlign: 'center',
        flexShrink: 0,
    },
    infoAIInput: {
        height: 144,
    },
    progressDots: {
        flexShrink: 0,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.6,
        whiteSpace: 'pre-line',
    },
    description: {
        fontSize: 14,
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    button: {
        width: 290,
        height: 48,
        padding: 0,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.28,
        flexShrink: 0,
    },
});
